import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import {
  PurchaseDomainDialog,
} from '../Dialogs';
import { startEditWebsiteRoot } from 'store/actions/website';

const styles = theme => ({
  root: {
    maxWidth: '470px',
  },
  spacer: {
    height: '12px',
  }
});

class DomainSelect extends Component {
  constructor(props){
    super(props);
    this.state ={
      showDialog: false,
    };
  }

  render() {
    const {
      classes,
      websiteRoot,
      orgDomain,
      showValidation,
      validation,
      onDataChange,
      startEditWebsiteRoot,
      help
    } = this.props;
    const { showDialog } = this.state;

    return (
      <Card className={classes.root}>
        <PurchaseDomainDialog
          showDialog={showDialog}
          handleClose={() => this.setState({ showDialog: false })}
        />
        <CardHeader title="Choose a Domain Name" />
        <CardContent className={classes.content}>
          <Typography>
            Here you can change the name of your Sub Domain or purchase
            your own Business Domain.
          </Typography>
          <div className={classes.spacer} />
          <div className={classes.spacer} />
          <div className={classes.spacer} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subheading">
              Couraggo Sub Domain
            </Typography>
            <div className={classes.spacer} />
            <TextField
              error={(showValidation && !!validation.validateField("subDomain"))}
              helperText={(showValidation && validation.validateField("subDomain"))}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              label="Sub Domain"
              margin="none"
              value={websiteRoot.subDomain}
              onChange={(event) => {
                onDataChange();
                startEditWebsiteRoot({subDomain: event.target.value});
              }}
            />
            <div className={classes.spacer} />
            <TextField
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              label="Full Website Address"
              margin="none"
              value={`${websiteRoot.subDomain}.couraggo.com`}
              disabled
            />
            <div className={classes.spacer} />
            <div className={classes.spacer} />
            <div className={classes.spacer} />
            <div className={classes.spacer} />
            <Typography
              style={{ alignSelf: 'center'}}
            >
              OR
            </Typography>
            <div className={classes.spacer} />
            <div className={classes.spacer} />
            <div className={classes.spacer} />
            <div className={classes.spacer} />
            <Typography variant="subheading">
              Your Business Domain
            </Typography>
            <div className={classes.spacer} />
            <TextField
              disabled
              error={(showValidation && !!validation.validateField("customDomain"))}
              helperText={(showValidation && validation.validateField("customDomain"))}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              label="Business Domain"
              margin="none"
              value={websiteRoot.customDomain}
              onChange={(event) => {
                onDataChange();
                startEditWebsiteRoot({customDomain: event.target.value});
              }}
            />
            <div className={classes.spacer} />
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                this.setState({ showDialog: true });
              }}
            >
              Get Business Domain
            </Button>
          </div>
        </CardContent>
      </Card>
    );
  }
}

const mapStateToProps = state => {
  const { website: websiteValidation } = state.validation;
  const organization = state.accountState.organizations[0];
  const oid = organization ? organization.id : undefined;
  const orgDomains = state.orgDomains;
  let orgDomain = {};
  orgDomains.forEach(item => {
    if (oid && item.oid === oid) {
      orgDomain = item;
    }
  });

  let validation = {};
  if (websiteValidation && websiteValidation.root) {
    validation = websiteValidation.root;
  }

  return({
    websiteRoot: state.websiteState.root,
    validation,
    help: state.help,
    orgDomain,
  });
}

const mapDispatchToProps = {
  startEditWebsiteRoot
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(DomainSelect);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Domain/DomainSelect.jsx